import { CompanyListItem } from './company.model';

export interface SellerListItem extends CompanyListItem {
  salesUsername?: string;
  operationsUsername?: string;
  statusName: SellerStatus;
}

export enum SellerStatus {
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  REJECTED = 'REJECTED',
  TARGET = 'TARGET',
  NOT_INTERESTED = 'NOT_INTERESTED',
  PENDING_CONTRACT = 'PENDING_CONTRACT',
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED',

  LEAD = 'LEAD',
  DANGEROUS = 'DANGEROUS',
  SELLING = 'SELLING',
  NOT_SELLING = 'NOT_SELLING',
  TO_REVIEW = 'TO_REVIEW',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
}

export enum SellerFakeStatus {
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  REJECTED = 'REJECTED',
  TARGET = 'TARGET',
  NOT_INTERESTED = 'NOT_INTERESTED',
  PENDING_CONTRACT = 'PENDING_CONTRACT',
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED',
  LEAD = 'LEAD',
}
